import React, { Component } from 'react';
import { Table } from 'react-bootstrap';
import CategoryListRow from './CategoryListRow';

export default class CategoryList extends Component {

    handleEditCategoryName = (id, name, oldName) => {

        let category = this.getCategory(id);
        if (category.name === name) return;

        category.name = name;
        this.props.onEditCategory(category);
    }

    handleEditCategoryCode = (id, code, oldCode) => {

        let category = this.getCategory(id);
        if (category.code === code) return;

        category.code = code;
        this.props.onEditCategory(category);
    }

    handleEditCategoryRisk = (id, risk, oldRisk) => {

        let category = this.getCategory(id);
        if (category.riskType === risk) return;

        category.riskType = risk;
        this.props.onEditCategory(category);
    }

    handleEditCategoryIsAvailable = (id, isAvailable, oldIsAvailable) => {

        let category = this.getCategory(id);
        if (category.isAvailable === isAvailable) return;

        category.isAvailable = isAvailable;
        this.props.onEditCategory(category);
    }

    handleEditCategoryIsActive = (id, isActive, oldIsActive) => {

        let category = this.getCategory(id);
        if (category.isActive === isActive) return;

        category.isActive = isActive;
        this.props.onEditCategory(category);
    }

    handleEditCategoryHighlightWhenFound = (id, highlightWhenFound, oldhighlightWhenFound) => {
        let category = this.getCategory(id);
        if (category.highlightWhenFound === highlightWhenFound) return;

        category.isActive = highlightWhenFound || category.warnWhenMissing;
        category.highlightWhenFound = highlightWhenFound;
        this.props.onEditCategory(category);
    }

    handleEditCategoryWarnWhenMissing = (id, warnWhenMissing, oldWarnWhenMissing) => {
        let category = this.getCategory(id);
        if (category.warnWhenMissing === warnWhenMissing) return;

        category.isActive = category.highlightWhenFound || warnWhenMissing;
        category.warnWhenMissing = warnWhenMissing;
        this.props.onEditCategory(category);
    }

    getCategory = (id) => {
        let category = this.props.items.find(x => x.categoryId === id);
        if (!category) return null;

        return Object.assign({}, category);
    }

    renderRows = () => {

        let toDisplay = this.props.items;//.filter(x => x.shouldDisplay);
        toDisplay = toDisplay.filter(x => !x.isRedflag);
        toDisplay.sort((a, b) => a.name.localeCompare(b.name));

        return toDisplay.map((category, i) => {
            return (
                <CategoryListRow
                    key={category.categoryId}
                    index={i}
                    id={category.categoryId}
                    name={category.name}
                    code={category.code}
                    riskType={category.riskType}
                    isActive={category.isActive}
                    isAvailable={category.isAvailable}
                    highlightWhenFound={category.highlightWhenFound}
                    warnWhenMissing={category.warnWhenMissing}
                    packageId={this.props.packageId}
                    categories={this.props.categories}
                    isLoading={this.props.isLoading}
                    onEditName={this.handleEditCategoryName}
                    onEditCode={this.handleEditCategoryCode}
                    onEditRisk={this.handleEditCategoryRisk}
                    onEditIsAvailable={this.handleEditCategoryIsAvailable}
                    onEditIsActive={this.handleEditCategoryIsActive}
                    onEditHighlightWhenFound={this.handleEditCategoryHighlightWhenFound}
                    onEditWarnWhenMissing={this.handleEditCategoryWarnWhenMissing}
                />);
        });
    }

    render() {
        return (
            <Table className="category-list" striped bordered hover size="sm">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Code</th>
                        <th>Importance</th>
                        <th>Is available</th>
                        <th>Is active</th>
                        <th>Highlight</th>
                        <th>Missing</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderRows()}
                </tbody>
            </Table >
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CategoryView/CategoryList.js